import { render, staticRenderFns } from "./VolumeUnit.vue?vue&type=template&id=06a05ba3"
import script from "./VolumeUnit.vue?vue&type=script&lang=js"
export * from "./VolumeUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports